import { selectMerchant } from "@redux";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { BudgeRightArrow, MemberCrown, MemberDiamond, MemberStar } from "../icon";

interface IProps {
    color: string;
    icon?: string;
    themeColor?: string;
    tierName?: string;
    onClick?: () => void;
}
interface CItem {
    name: string;
    color: string;
    value: string[];
}
// if tier color is not have in familiy colors, need to get theme color to apply button color
export const BudgeButton = (props: IProps) => {
    const { themes } = useSelector(selectMerchant);
    const themeMode = themes?.themeMode || "light";
    const { color, icon, themeColor, onClick, tierName } = props;
    const getFamilyColor = (colors: CItem[]) => {
        const familyColors = colors.filter((item) => item.color === color);
        if (familyColors.length === 0) {
            return { familyColor: [color, color].join() };
        } else {
            return { familyColor: familyColors[0].value.join() };
        }
    };
    // const { familyColor } = getFamilyColor(FAMILY_COLOR_BENEFITS); // need color array string to make radient btn color
    const familyColor = [color, color].join();
    return (
        <StyledOuterLayout color={familyColor || ""}>
            <StyledButton
                color={familyColor || ""}
                themeMode={themeMode || "light"}
                onClick={onClick}
            >
                <StyledIconLayout>
                    {(icon === undefined || icon === "") && (
                        <MemberStar color={`${themeMode === "dark" ? "black" : "white"}`} />
                    )}
                    {icon === "star" && (
                        <MemberStar color={`${themeMode === "dark" ? "black" : "white"}`} />
                    )}
                    {icon === "crown" && (
                        <MemberCrown color={`${themeMode === "dark" ? "black" : "white"}`} />
                    )}
                    {icon === "diamond" && (
                        <MemberDiamond color={`${themeMode === "dark" ? "black" : "white"}`} />
                    )}
                </StyledIconLayout>
                <span className="name">{tierName}</span>
                <BudgeRightArrow stoke={`${themeMode === "dark" ? "black" : "white"}`} />
            </StyledButton>
        </StyledOuterLayout>
    );
};

const StyledIconLayout = styled.div`
    border-radius: 50%;
    background: rgb(232 225 225 / 50%);
    /* margin-right: 2px; */
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
const StyledOuterLayout = styled.div<{ color: string }>`
    background: linear-gradient(to bottom, ${(p) => p.color});
    width: fit-content;
    padding: 2px;
    border-radius: 14px;
`;
const StyledButton = styled.button<{ color: string; themeMode: string }>`
    text-transform: uppercase;
    color: white;
    padding: 4px;
    height: 26px;
    border-radius: 13px;
    background: linear-gradient(to bottom, ${(p) => p.color});
    border: 0.5px solid white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 10px;
    column-gap: 2px;
    .name {
        margin-top: 2px;
        max-width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: -4px;
        color: ${(p) => (p.themeMode === "dark" ? "black" : "white")};
    }
`;
